module.exports = __webpack_public_path__ + "img/banner.b1be3da5.png";